import { Component } from '@angular/core';

@Component({
  selector: 'app-sso-error-page',
  standalone: true,
  imports: [],
  templateUrl: './sso.error.page.html',
})
export class SSOErrorPage {
  _common=_common;
  constructor() {}
  ngOnInit() {}
}
